import { setCookie } from 'cookies-next'
import { addDays } from 'date-fns'

export const ACCEPT_COOKIE_KEY = 'cookie-consent'

export const saveCookieChoice = (accepted: boolean) => {
  setCookie(ACCEPT_COOKIE_KEY, `${accepted}`, {
    sameSite: `lax`,
    path: `/`,
    expires: addDays(new Date(), 180)
  })
}
